import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEvent, HttpSentEvent } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  userAuthenticationDetails: any = null;
  options: any;
  roles: any = null;
  userdetails: any = null;

  patchApproveMatriX: any;
  passApprovematrixForReport: any;
  limitTypes: any;
  confirmationProbationWhomSetup: any;
  allReimbursementData: any = [];
  checkAuthorityName: any;
  notcompletedElcmSetUp: any;
  reportingManagerForElcm: any;
  selectedOptionForAppoinmentLetter: any;
  selectedOptionSalaryBreakUp: any;
  selectedOptionForExitPermission: any;
  tokenforEss: any;
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute
  ) {}
  getToken() {
    return (this.options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('currentToken')
      })
    });
  }
  private apiUrl = 'https://hrwebapi.infowanhr.com/Emp';
  getHrwebAPIEmployees(domainId: any): Observable<any> {
    const headers = new HttpHeaders().set('domainId', domainId);
    return this.http.get(this.apiUrl, { headers });
  }

  public callPostServiceForLogin(url: any, param: any): Observable<HttpEvent<any>> {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(url, JSON.stringify(param), { headers: httpHeaders });
  }
  public callGetServiceWithoutToken(url: any): Observable<HttpEvent<any>> {
    return this.http.get<any>(url);
  }
  public callPostService(url: any, param: any): Observable<HttpEvent<any>> {
    return this.http.post<any>(url, JSON.stringify(param), this.getToken());
  }
  public callGetService(url: any): Observable<HttpEvent<any>> {
    return this.http.get<any>(url, this.getToken());
  }
  public callPostServiceWithoutToken(url: any, param: any): Observable<HttpEvent<any>> {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(url, JSON.stringify(param), { headers: httpHeaders });
  }
  public getRequest(url: string, data: HttpParams): Observable<any> {
    return data != null ? this.http.get(url, { params: data }) : this.http.get(url);
  }
  public callPutService(url: any, param: any): Observable<HttpEvent<any>> {
    return this.http.put<any>(url, JSON.stringify(param), this.getToken());
  }
  public callDeleteService(url: any): Observable<HttpEvent<any>> {
    return this.http.delete<any>(url, this.getToken());
  }
  public submitFormService(url: any, FormData: any): Observable<HttpEvent<any>> {
    let httpHeaders = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('currentToken')
    });
    return this.http.post<any>(url, FormData, { headers: httpHeaders });
  }
  public submitFileService(url: string, formData: FormData, method: 'POST' | 'PUT' = 'POST'): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('currentToken')
    });

    if (method === 'PUT') {
      return this.http.put<any>(url, formData, { headers });
    } else {
      return this.http.post<any>(url, formData, { headers });
    }
  }
  public submitFileServiceWithoutAuth(url: string, formData: FormData, method: 'POST' | 'PUT' = 'POST'): Observable<any> {
    if (method === 'PUT') {
      return this.http.put<any>(url, formData);
    } else {
      return this.http.post<any>(url, formData);
    }
  }

  public saveExpence(url: any, FormData: any): Observable<HttpEvent<any>> {
    let httpHeaders = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('currentToken')
    });
    return this.http.post<any>(url, FormData, { headers: httpHeaders });
  }

  private reimbursementDataSubject = new BehaviorSubject<any[]>([]);
  reimbursementData$ = this.reimbursementDataSubject.asObservable();

  setReimbursementData(data: any[]) {
    this.reimbursementDataSubject.next(data);
  }

  getReimbursementData(): any[] {
    return this.reimbursementDataSubject.getValue();
  }

  private employeData = new BehaviorSubject<any[]>([]);
  employeIDUnderManager = this.employeData.asObservable();

  setemployeData(data: any[]) {
    this.employeData.next(data);
  }

  getEmployeeData(): any[] {
    return this.employeData.getValue();
  }

  private employeeCodeDataList = new BehaviorSubject<any>(null);

  // Expose an observable for the component to subscribe
  employeeCodeData$: Observable<any> = this.employeeCodeDataList.asObservable();

  // Method to update data
  setEmployeeCodeData(data: any) {
    this.employeeCodeDataList.next(data);
  }

  private notcompletdSetUP = new BehaviorSubject<any[]>([]);
  notcompletdSetUP$ = this.notcompletdSetUP.asObservable();

  setnotcompletdSetUP(data: any[]) {
    this.notcompletdSetUP.next(data);
  }

  getnotcompletdSetUP(): any[] {
    return this.notcompletdSetUP.getValue();
  }

  getDwonloadBlobFile(url: string): Observable<Blob> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('currentToken')
    });
    return this.http.get(url, { headers: headers, responseType: 'blob' });
  }
}
